import defaultLocale from 'locales/en.json';
import { Texts } from 'types';

export const getDefaultTranslations = (): Texts => defaultLocale;